var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.isHidden,
          expression: "!isHidden"
        }
      ],
      staticClass: "betType-Parlay",
      class: [
        _vm.tab,
        _vm.statusToConfirm ? "statusToConfirm-" + _vm.statusToConfirm : "",
        { SGM: _vm.isSGM }
      ]
    },
    [
      _vm.isSGM ||
      (_vm.allowedBetTypesAndReturns && _vm.allowedBetTypesAndReturns.UnitCount)
        ? _c(
            "div",
            {
              staticClass: "betType",
              class: [_vm.tab, { SGM: _vm.isSGM, SGMplus: _vm.isSgpA }]
            },
            [
              _c(
                "div",
                { staticClass: "specialOffers-offer-container" },
                [
                  _c("special-offers", {
                    attrs: {
                      mode: "offerMode",
                      id: _vm.id,
                      isSGP: _vm.isSGM,
                      allowedBetTypesAndReturns: _vm.allowedBetTypesAndReturns
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.isSGM
                ? _c(
                    "div",
                    { staticClass: "heading SGM-heading" },
                    [
                      _vm.idfosporttype && _vm.brandTemplate !== "generic_2"
                        ? _c("icon", {
                            staticClass: "sports-icon-sgp",
                            attrs: {
                              name:
                                "icon-" +
                                _vm.idfosporttype
                                  .split(" ")
                                  .join("")
                                  .toLowerCase()
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", { staticClass: "SGM-event-name" }, [
                        _vm._v(_vm._s(_vm.isSGM))
                      ]),
                      _vm._v(" "),
                      _vm.betslipLayout2 &&
                      _vm.isSGM &&
                      _vm.allowedBetTypesAndReturns.Price &&
                      _vm.parlayTeamsNo &&
                      _vm.parlayTeamsNo.valid
                        ? _c("span", { staticClass: "price" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.formattedOdds) +
                                "\n      "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.parlayTeamsNo.valid
                        ? _c("div", { staticClass: "SGM-selections-heading" }, [
                            _vm._v(
                              "\n        " +
                                _vm._s(_vm.parlayTeamsNo.valid) +
                                "\n        "
                            ),
                            _vm.parlayTeamsNo.valid == 1
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "BetSlip.tab.SGM.heading.selection"
                                      )
                                    )
                                  )
                                ])
                              : _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "BetSlip.tab.SGM.heading.selections"
                                      )
                                    )
                                  )
                                ])
                          ])
                        : _c("div", { staticClass: "no-SGM-spacer" })
                    ],
                    1
                  )
                : _vm.isSgpA
                ? _c("div", { staticClass: "heading-SGP-plus" }, [
                    _c("div", { staticClass: "sgpPlus" }, [
                      _c("span", { staticClass: "sgp-tag" }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.participants.legs) +
                            " " +
                            _vm._s(
                              _vm.$t("BetSlip.tab.Standard.heading.SGP_PARLAY")
                            )
                        )
                      ]),
                      _vm._v(" "),
                      _vm.sgpPlusMarkAsNew
                        ? _c("span", { staticClass: "new-indicator" }, [
                            _vm._v(_vm._s(_vm.$t("BetSlip.tab.title.SGP.new")))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.betslipLayout2
                        ? _c("span", { staticClass: "price" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.formattedOdds) +
                                "\n        "
                            )
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "sgpplusparticipants" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t(
                              "BetSlip.tab.Standard.heading.SGP_PARLAY.participants" +
                                (_vm.participants.sgpNo ? ".sgm" : "") +
                                (_vm.participants.sgpNo > 1 ? "s" : "") +
                                (_vm.participants.fosNo ? ".fos" : "") +
                                (_vm.participants.fosNo > 1 ? "s" : ""),
                              {
                                sgp: _vm.participants.sgpNo,
                                fos: _vm.participants.fosNo
                              }
                            )
                          ) +
                          "\n      "
                      )
                    ])
                  ])
                : _c("div", { staticClass: "title-parlay" }, [
                    _c("div", { staticClass: "betType_header_title" }, [
                      _c("span", { staticClass: "parly_first" }, [
                        _vm.teaserLevel && !_vm.spread && _vm.isTeaserReversed
                          ? _c("span", { staticClass: "Reversed-Teaser" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "BetSlip.tab.TEASER.heading.level.reversed.prefix"
                                  )
                                )
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.allowedBetTypesAndReturns &&
                        _vm.allowedBetTypesAndReturns.Name
                          ? _c(
                              "span",
                              { staticClass: "allowedBetTypesAndReturns-Name" },
                              [
                                _vm._v(
                                  _vm._s(_vm.allowedBetTypesAndReturns.Name)
                                )
                              ]
                            )
                          : _c("span", { staticClass: "generic-Name" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "BetSlip.tab." +
                                      _vm.tab +
                                      ".heading.PARLAY_FIRST"
                                  )
                                )
                              )
                            ]),
                        _vm._v(" "),
                        _vm.teaserLevel
                          ? _c(
                              "span",
                              {
                                key: "spread-" + _vm.spread,
                                staticClass: "teaserLevel"
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t(
                                        "BetSlip.tab.TEASER.heading.level" +
                                          (_vm.brandKey === "circa" &&
                                          _vm.spread
                                            ? ".spread"
                                            : _vm.spread
                                            ? ".spread"
                                            : _vm.isTeaserReversed
                                            ? ".reversed"
                                            : ""),
                                        {
                                          spread: _vm.spread,
                                          tl: _vm.teaserLevel
                                        }
                                      )
                                    ) +
                                    "\n          "
                                )
                              ]
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          key:
                            "teams_num-" +
                            (_vm.allowedBetTypesAndReturns &&
                              _vm.allowedBetTypesAndReturns.ParticipantsNo),
                          staticClass: "teams_num"
                        },
                        [
                          _vm._v(
                            "\n           " +
                              _vm._s(
                                _vm.allowedBetTypesAndReturns &&
                                  _vm.allowedBetTypesAndReturns.ParticipantsNo
                              ) +
                              "\n          "
                          ),
                          _c("span", { key: "parly_second" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "BetSlip.tab.Standard.heading.PARLAY_SECOND"
                                )
                              )
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _vm.statusToConfirm
                        ? _c("span", { staticClass: "statusToConfirm" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "BetSlip.placement.bet." + _vm.statusToConfirm
                                )
                              )
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isForBB
                        ? _c(
                            "span",
                            { staticClass: "isForBB float-right" },
                            [
                              _c("icon", {
                                attrs: { name: "icon-available-for-bb-white" }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.betslipLayout2
                        ? _c(
                            "span",
                            { staticClass: "special-offers-eligible" },
                            [
                              _c("special-offers", {
                                attrs: {
                                  mode: "eligible",
                                  id: _vm.id,
                                  isSGP: _vm.isSGM,
                                  allowedBetTypesAndReturns:
                                    _vm.allowedBetTypesAndReturns
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _vm.betslipLayout2
                      ? _c("div", { staticClass: "price_div" }, [
                          _c("span", { staticClass: "price" }, [
                            _vm._v(_vm._s(_vm.formattedOdds))
                          ])
                        ])
                      : _vm._e()
                  ]),
              _vm._v(" "),
              _vm.betslipLayout2
                ? _c(
                    "span",
                    { staticClass: "special-offers-eligible" },
                    [
                      _c("special-offers", {
                        attrs: {
                          mode: "eligible",
                          id: _vm.id,
                          isSGP: _vm.isSGM,
                          allowedBetTypesAndReturns:
                            _vm.allowedBetTypesAndReturns
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isSGM ||
              (_vm.isSGM &&
                _vm.allowedBetTypesAndReturns.Price &&
                _vm.parlayTeamsNo &&
                _vm.parlayTeamsNo.valid)
                ? _c("div", { staticClass: "bet_content" }, [
                    !_vm.betslipLayout2
                      ? _c("div", { staticClass: "odds_div" }, [
                          _c("span", { staticClass: "price_title" }, [
                            _vm._v(_vm._s(_vm.$t("BetSlip.oddsprice")))
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "odds" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.formattedOdds) +
                                "\n        "
                            )
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "stake-n-return" },
                      [
                        _c("stake-and-return", {
                          staticClass: "clear-both",
                          attrs: {
                            id: _vm.isSGM
                              ? _vm.allowedBetTypesAndReturns.Entity
                              : _vm.id,
                            perType: "PerBetType",
                            tab: _vm.isSGM ? "XP" : _vm.tab,
                            currentBetSlipState: _vm.currentBetSlipState,
                            allowedBetTypesAndReturns:
                              _vm.allowedBetTypesAndReturns,
                            teaserGroupId: _vm.teaserGroupId,
                            isSGM: _vm.isSGM,
                            sgmPath: _vm.sgmPath ? _vm.sgmPath.split(".") : "",
                            statusToConfirm: _vm.statusToConfirm
                          },
                          on: { hideBetType: _vm.hideBetType }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4d83bc19", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d83bc19","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/betslipV2/betTypes/betTypeParlay.vue
// module id = null
// module chunks = 